<template>
  <div class="content if-profile report-tab">
    <div class="md-layout ratios-report">
      <MRReportHeader :headerData="this.headerData" />

      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 marketprof-competitors p-0 mt-4"
      >
        <div class="finanical-report-messages">
          <h1 class="section_header">Startups</h1>
          <!-- <div class="">
            <md-dialog :md-active.sync="showDialog">
              <p>
                How vigorous is entrepreneurship in your market area? In
                addition to displaying the market area startup population (two
                years or less), the table calculates average startup sales,
                which frequently diverge from the industry and small business
                average. Industry startup market share is also displayed.
              </p>
              <p>
                How does startup activity compare to the US industry benchmark?
                <br />
                <br />
                Startup rates are calculated by dividing the number of industry
                market startups by the total number of operations for which an
                age is known. The Local startup index compares market area and
                national start rates, presenting them as a two decimal index
                where identical rates would be 1.00.
              </p>
            </md-dialog>
            <md-card-header class="md-card-header-icon messages-box">
              <div class="card-icon md-ripple" @click="showDialog = true">
                <md-icon class="icon-arrow">double_arrow </md-icon>
                <md-icon>chat_bubble</md-icon>
              </div>
            </md-card-header>
          </div>-->
        </div>
        <div class="navbar md-toolbar md-transparent md-elevation-4 finanical-report-messages p-0">
          <nav-tabs-card no-label md-elevation="0">
            <template slot="content">
              <md-tabs md-alignment="left" class="if_card">
                <md-tab md-label="Values" md-icon="window" class="p-0">
                  <div class="md-layout">
                    <div class="md-layout-item md-size-100 p-0">
                      <md-card class="m-0">
                        <md-card-header>Startup Performance</md-card-header>
                        <md-card-content>
                          <div class="md-layout p-4">
                            <div class="md-layout-item md-size-100 blue-tbl">
                              <md-card class="md-card-profile">
                                <md-card-header class="md-card-header-icon">
                                  <h4 class="title m-0">
                                    <div
                                      class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                                    >Startup Performance (Firms)</div>
                                  </h4>
                                  <!-- <h4 class="title text-left">
                                    Startup Performance (Firms)
                                  </h4>-->
                                </md-card-header>
                                <md-card-content>
                                  <div class="md-layout">
                                    <div
                                      class="md-layout-item md-medium-size-100 md-size-100 sub_table p-0 border-0"
                                    >
                                      <md-table
                                        v-model="tableDataStartupPerformance"
                                        table-header-color="blue"
                                        class="profit-and-loss-table"
                                      >
                                        <md-table-row slot="md-table-row" slot-scope="{ item }">
                                          <md-table-cell class="md-table-side-label">{{ item.name }}</md-table-cell>
                                          <md-table-cell
                                            v-for="key in Object.keys(
                                              item.dates
                                            )"
                                            :key="key"
                                            :md-label="years[key]"
                                          >{{ item.dates[key] }}</md-table-cell>
                                        </md-table-row>
                                      </md-table>
                                    </div>
                                  </div>
                                </md-card-content>
                              </md-card>
                            </div>
                          </div>
                          <div class="md-layout px-4">
                            <div class="md-layout-item md-medium-size-100 md-size-50">
                              <md-card class="md-card-profile">
                                <md-card-content>
                                  <chart-card
                                    header-animation="false"
                                    :chart-data="
                                      startupPerformanceLineChart.data
                                    "
                                    :chart-options="
                                      startupPerformanceLineChart.options
                                    "
                                    chart-type="Bar"
                                    header-icon
                                    chart-inside-content
                                    no-footer
                                    background-color="blue"
                                  >
                                    <template slot="chartInsideHeader">
                                      <h4 class="title m-0">
                                        <div
                                          class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                                        >Industry Startups (2 Years)</div>
                                      </h4>
                                      <!-- <h4 class="title">Industry Startups (2 Years)</h4> -->
                                    </template>
                                  </chart-card>
                                  <div class="pie-line" v-if="startupPerformanceLineChart && startupPerformanceLineChart.data && startupPerformanceLineChart.data.series">
                                    <ul>
                                      <li v-for="(label, index) in startupPerformanceLineChart.data.series" :key="index + '_label'"><span class=""><i :class="'fa fa-square ' + 'chart-label-color-' + index"></i></span> {{ label.name }}</li>
                                    </ul>
                                  </div>
                                </md-card-content>
                              </md-card>
                            </div>
                             <div v-if="cmnText" class="md-layout-item md-medium-size-100 md-size-50">
                              <md-card class="md-card-profile">
                                <md-card-header>
                                  <h4 class="title m-0">
                                    <div
                                      class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                                    >Competitive Market Narrative</div>
                                  </h4>
                                </md-card-header>
                                <md-card-content>
                                  <div class="extra_space">
                                    <!-- <h4 class="Performance Scores">
                                    Competitive Market Narrative
                                    </h4>-->
                                    <p>
                                      {{cmnText.startups}}
                                    </p>
                                  </div>
                                </md-card-content>
                              </md-card>
                            </div>
                            <div class="md-layout-item md-medium-size-100 md-size-50">
                              <md-card class="md-card-profile ">
                                <md-card-header>
                                  <h4 class="title m-0">
                                    <div
                                      class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                                    >
                                      <md-icon class="color-white">article</md-icon> Startups
                                    </div>
                                  </h4>
                                </md-card-header>
                                <md-card-content>
                                  <div class="md-layout">
                                    <div class="md-layout-item md-medium-size-100 md-size-100">
                                      <div class="extra_space">
                                        <!-- <h4 class="Performance Scores">
                                          Competitive Market Narrative
                                        </h4>-->
                                        <p>
                                          How vigorous is entrepreneurship in your market area? In addition to displaying the market area
                                          startup population (two years or less), the table calculates average startup sales, which frequently
                                          diverge from the industry and small business average.
                                          Industry startup market share is also displayed.'
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </md-card-content>
                              </md-card>
                            </div>
                          </div>
                        </md-card-content>
                      </md-card>
                    </div>
                  </div>
                </md-tab>
                <md-tab md-label="Index/Chart" md-icon="legend_toggle" class="p-0">
                  <div class="md-layout">
                    <div class="md-layout-item md-size-100 p-0">
                      <md-card class="m-0">
                        <md-card-header>Index/Chart</md-card-header>
                        <md-card-content>
                          <div class="md-layout p-4">
                            <div class="md-layout-item md-size-100">
                              <md-card class="md-card-profile">
                                <md-card-header class="md-card-header-icon">
                                  <h4 class="title m-0">
                                    <div
                                      class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                                    >
                                      Startup Activity Rates (Firms and
                                      Branches)
                                    </div>
                                  </h4>
                                  <!-- <h4 class="title text-left">
                                      Startup Activity Rates (Firms and Branches)
                                  </h4>-->
                                </md-card-header>
                                <md-card-content>
                                  <div class="md-layout">
                                    <div
                                      class="md-layout-item md-medium-size-100 md-size-100 sub_table p-0 border-0"
                                    >
                                      <md-table
                                        v-model="tableDataStartupActivityRates"
                                        table-header-color="blue"
                                        class="profit-and-loss-table"
                                      >
                                        <md-table-row slot="md-table-row" slot-scope="{ item }">
                                          <md-table-cell class="md-table-side-label">{{ item.name }}</md-table-cell>
                                          <md-table-cell
                                            v-for="key in Object.keys(
                                              item.dates
                                            )"
                                            :key="key"
                                            :md-label="years[key]"
                                          >{{ item.dates[key] }}</md-table-cell>
                                        </md-table-row>
                                      </md-table>
                                    </div>
                                  </div>
                                </md-card-content>
                              </md-card>
                            </div>
                          </div>
                          <div class="md-layout px-4">
                            <div class="md-layout-item md-medium-size-100 md-size-50">
                              <md-card class="md-card-profile">
                                <md-card-content>
                                  <chart-card
                                    header-animation="false"
                                    :chart-data="
                                      startupActivityRatesLineChart.data
                                    "
                                    :chart-options="
                                      startupActivityRatesLineChart.options
                                    "
                                    chart-type="Line"
                                    header-icon
                                    chart-inside-content
                                    no-footer
                                    background-color="blue"
                                  >
                                    <template slot="chartInsideHeader">
                                      <h4 class="title m-0">
                                        <div
                                          class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                                        >Industry Startups (2 Years)</div>
                                      </h4>
                                      <!-- <h4 class="title">Industry Startups (2 Years)</h4> -->
                                    </template>
                                  </chart-card>
                                  <div class="pie-line" v-if="startupActivityRatesLineChart && startupActivityRatesLineChart.data && startupActivityRatesLineChart.data.series">
                                    <ul>
                                      <li v-for="(label, index) in startupActivityRatesLineChart.data.series" :key="index + '_label'"><span class=""><i :class="'fa fa-square ' + 'chart-label-color-' + index"></i></span> {{ label.name }}</li>
                                    </ul>
                                  </div>
                                </md-card-content>
                              </md-card>
                            </div>
                           <div class="md-layout-item md-medium-size-100 md-size-50">
                              <md-card class="md-card-profile">
                                <md-card-header>
                                  <h4 class="title m-0">
                                    <div
                                      class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                                    >Competitive Market Narrative</div>
                                  </h4>
                                </md-card-header>
                                <md-card-content>
                                  <div class="extra_space">
                                    <!-- <h4 class="Performance Scores">
                                      Competitive Market Narrative
                                    </h4>-->
                                    <p>
                                      How vigorous is industry entrepreneurship
                                      in the market area? Defined as operations
                                      in business for two years or less, 43
                                      independent industry startups and new
                                      branch operations were identified in the
                                      market area in October 2017, creating a
                                      new operation rate of 6.03% in the most
                                      recent analysis year, less than the
                                      national rate of 6.06%. Unusually low new
                                      operation rates can indicate market
                                      saturation or lack of perceived
                                      opportunity, while high rates suggest both
                                      opportunity and the recognition of it.​
                                      <br />
                                      <br />Startup rates are calculated by dividing
                                      the number of industry market startups by
                                      the total number of operations for which
                                      an age is known. (Due to the limited
                                      number of new operations at any given
                                      time, this indicator may be less useful in
                                      small local market areas.) ​
                                      <br />
                                      <br />Industry startup operations hold a 7.68%
                                      share of the total local industry market,
                                      with average sales of $1,718,359. Due to
                                      the variations in scale, startup sales
                                      often diverge from the industry and small
                                      business average.​
                                      <br />
                                      <br />
                                    </p>
                                  </div>
                                </md-card-content>
                              </md-card>
                              <md-card class="md-card-profile">
                                <md-card-header>
                                  <h4 class="title m-0">
                                    <div
                                      class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                                    >
                                      <md-icon class="color-white">article</md-icon> Startups
                                    </div>
                                  </h4>
                                </md-card-header>
                                <md-card-content>
                                  <div class="md-layout">
                                    <div class="md-layout-item md-medium-size-100 md-size-100">
                                      <div class="extra_space">
                                        <!-- <h4 class="Performance Scores">
                                          Competitive Market Narrative
                                        </h4>-->
                                        <p>
                                          How vigorous is entrepreneurship in your market area? In addition to displaying the market area
                                          startup population (two years or less), the table calculates average startup sales, which frequently
                                          diverge from the industry and small business average.
                                          Industry startup market share is also displayed.'
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </md-card-content>
                              </md-card>
                            </div>
                            <div class="md-layout-item md-medium-size-100 md-size-50">

                            </div>
                          </div>
                        </md-card-content>
                      </md-card>
                    </div>
                  </div>
                </md-tab>
              </md-tabs>
            </template>
          </nav-tabs-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ChartCard, NavTabsCard } from '@/components';
import { mapState } from 'vuex';
import MRReportHeader from './_partials/MRReportHeader.vue';

export default {
  components: {
    ChartCard,
    NavTabsCard,
    MRReportHeader,
  },
  props: ['headerData'],
  data() {
    return {
      view: 'cash-flow-solvency',
      showDialog: false,
      tableDataStartupPerformance: [],
      tableDataStartupActivityRates: [],

      startupPerformanceLineChart: {
        data: {
          labels: [],
          series: [],
        },
        options: {
          lineSmooth: this.$Chartist.Interpolation.cardinal({
            tension: 10,
          }),
          axisY: {
            showGrid: true,
            offset: 40,
          },
          axisX: {
            showGrid: false,
          },
          showPoint: true,
          height: '300px',
        },
      },
      startupActivityRatesLineChart: {
        data: {
          labels: [],
          series: [],
        },
        options: {
          lineSmooth: this.$Chartist.Interpolation.cardinal({
            tension: 10,
          }),
          axisY: {
            showGrid: true,
            offset: 40,
          },
          axisX: {
            showGrid: false,
          },
          showPoint: true,
          height: '300px',
        },
      },
    };
  },
  computed: {
    ...mapState({
      startupsValues: (state) =>
        state.user.market_report.data.data['startupsValues'],
      startupsIndex: (state) =>
        state.user.market_report.data.data['startupsIndex'],
      years: (state) => state.user.market_report.data.years,
    }),
  },
  mounted() {
    let section = this.$route.query.section;

    if (!section) {
      section = 'cash-flow-solvency';
    }

    this.switchView(section);
    let me = this;

    this.tableDataStartupPerformance = Object.entries(
      this.startupsValues
    ).map(([table, data]) => ({ name: table, dates: Object.values(data) }));
    this.tableDataStartupActivityRates = Object.entries(
      this.startupsIndex
    ).map(([table, data]) => ({ name: table, dates: Object.values(data) }));

    this.tableDataStartupPerformance.map((item) => {
      item.dates = item.dates.map((e) => {
        return me.numberWithCommas(e);
      });
      return item;
    });
    this.tableDataStartupActivityRates.map((item) => {
      item.dates = item.dates.map((e) => {
        return me.numberWithCommas(e);
      });
      return item;
    });

    // this.startupPerformanceLineChart.data = {
    //   labels: this.years,
    //   series: this.tableDataStartupPerformance.map((item) => ({
    //     name: item.name,
    //     data: item.dates,
    //   })),
    // };
    this.startupPerformanceLineChart.data = {
      labels: this.years,
      series: [{name: this.tableDataStartupPerformance[0].name, data: this.tableDataStartupPerformance[0].dates}]
    };
    this.startupActivityRatesLineChart.data = {
      labels: this.years,
      series: this.tableDataStartupActivityRates.map((item) => ({
        name: item.name,
        data: item.dates,
      })),
    };
  },
  watch: {
    '$route.query.section'() {
      let section = this.$route.query.section;

      if (!section) {
        section = 'cash-flow-solvency';
      }

      this.switchView(section);
    },
  },
  methods: {
    switchView: function (type) {
      this.view = type;
    },
    numberWithCommas(x) {
      if (x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      } else {
        return x;
      }
    },
  },
};
</script>
<style lang="scss">
.marketprof-competitors {
  .md-toolbar {
    .md-collapse {
      display: block;

      .md-collapse-content {
        p {
          padding-left: 20px;
        }
      }
    }
  }

  .competitors-list {
    .md-collapse-title {
      font-size: 12px;
      font-weight: 300;
      margin-left: 25px;
    }
    .md-icon {
      font-size: 12px;
      font-weight: 300;
      transform: rotate(-90deg);
      left: 0;
      color: rgba(0, 0, 0, 0.54);
    }
  }

  .competitors-map {
    iframe {
      height: 300px !important;
    }
  }
}
</style>
